import { useApiGet } from '@sierralabs/core-ui';
export function useFindEntityDeltas(id) {
    const { data, isLoading, error, get } = useApiGet(`entities/${id}/deltas`);
    return {
        entityDeltaList: data,
        isLoading,
        loadingError: error,
        getEntityDeltas: get
    };
}
//# sourceMappingURL=useFindEntityDeltas.js.map